<script>
import _ from 'lodash'
import Axios from 'axios'

import uiModal from '../daniel/ui-modal.vue'
import ApiImgPristine from '../daniel/api-img-pristine.vue'
import UiInput from '../daniel/ui-input.vue'

let emptyAsides = {
    headers: {},
    details: []
}

let pedidoDetallesFields = [
    {key: 'producto_nombre', label: 'Producto'},
    // {key: 'producto_descripcion_corta', label: 'Descripción'},
    // {key: 'cantidad', label: 'Cantidad'},
    {key: 'precio_lista', label: 'Precio'},
    {key: 'descuento', label: 'Descuento'},
    {key: 'subtotal', label: 'Subtotal'},
]

export default {
	components: { uiModal, ApiImgPristine, UiInput },
    name: 'ModalPedido',

    data: () => {
        return {
            display: false,
            isLoaded: false,
            workingPedidoId: null,
            asides: _.clone(emptyAsides),
            pedidoDetallesFields,
            modalTitle: null
        }
    },
    methods: {
        async loadUp(){
            try {
                let response = await Axios.get('orders/getdetail/' + this.workingPedidoId)
                if(response.status){
                    this.asides = response.data
                }
            } catch(e){
                console.error(e)
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                    color: 'warning',
                    duration: 7000
                })
            }
        },
        async openPedidoById(id, modalTitle){
            this.display = true;
            this.isLoaded = false;
            this.workingPedidoId = id;
            this.modalTitle = modalTitle;
            await this.loadUp();
            this.isLoaded = true;
        }
    }
}
</script>

<template>
    <ui-modal id="ModalPedido" v-model="display" >

        <div slot="header">{{modalTitle}}</div>

        <div v-if="isLoaded" id="ModalContent">

            <div class="row">
                <div class="col"><ui-input label="Número de orden" v-model="asides.headers.numero_orden" :readonly="true"/></div>
                <div class="col"><ui-input label="Estatus" v-model="asides.headers.pedido_estatus" :readonly="true"/></div>
                <div class="col"><ui-input label="Guía de rastreo" v-model="asides.headers.guia_rastreo" :readonly="true"/></div>
            </div>

            <b-table :items="asides.details" :fields="pedidoDetallesFields" class="ModalContentTable">

                <template #cell(precio_lista)="data">
                    {{data.value | currency}}
                </template>

                <template #cell(descuento)="data">
                    {{data.value | currency}}
                </template>

                <template #cell(subtotal)="data">
                    {{data.value | currency}}
                </template>

                <template #cell(producto_nombre)="data">
                    <api-img-pristine class="producto-img" :comp="data.item.producto_imagenes_id"/>
                    <span>
                        {{data.value}}
                        {{data.item.marca}}
                        {{data.item.modelo}}
                    </span>
                </template>

            </b-table>

            <div class="row row-subtotal">
                <div class="col col-subtotal">
                    <ui-input label="Sub total" v-model="asides.headers.subtotal_productos" :readonly="true"/>
                    <ui-input label="Envío" v-model="asides.headers.costo_envio" :readonly="true"/>
                    <ui-input label="Total" v-model="asides.headers.total" :readonly="true"/>
                </div>
            </div>

        </div>
        <div v-else>
            Cargando...
        </div>
    </ui-modal>
</template>

<style lang="less">
#ModalPedido{
    @size: 4em;
    #ModalContent {
        .ModalContentTable {
            margin-top: 1em;
            border-bottom: var(--ui-border);
        }
        .row-subtotal{
            justify-content: flex-end;
            .col-subtotal{
                max-width: 15em;
                // background: pink;
            }
        }
        .producto-img {
            width: @size;
            height: @size;
            object-fit: contain;
            border-radius: 0.5em;
        }
    }
}
</style>